import { Button } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import { AuthoringLegislationSelectorDialog } from "./authoring-legislation-selector-dialog"
import { updateProjectGroup } from "authoring/routes/project/group/controller/update-project-group"
import { useParams } from "react-router"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"
import { isGroupValid } from "../group/lib/is-group-valid"
import { useScheduleEditorActions } from "../schedule-editor/hooks/use-schedule-editor-actions"

export function AddReferencesButton({ props }) {
    const { projectId, groupId } = useParams()
    const { projectGroup, project, target } = useBoundContext()
    const { notifyDraftStructureChanged } = useScheduleEditorActions()
    const isLocked = isLockedToLegacy(project?.phase)
    const isDisabled = projectGroup.readOnly || isLocked || !isGroupValid(projectGroup, { canEditReferences: true })
    const legislationDialog = useDialog(<AuthoringLegislationSelectorDialog group={projectGroup} />, { maxWidth: "md" })

    return (
        <Button
            onClick={handleClick}
            data-cy="add-references-button"
            variant="contained"
            startIcon={<Iconify icon={"ic:round-add"} />}
            disabled={isDisabled}
            {...props}
        >
            Add References
        </Button>
    )

    async function handleClick() {
        const legislation = await legislationDialog()
        if (!legislation) return

        const updated = await updateProjectGroup({ projectId, group: { id: groupId, legislation } })
        if (!updated) {
            errorSnackbar("Failed to add references")
            return
        }

        successSnackbar("References added successfully")
        if (notifyDraftStructureChanged && target) {
            target.legislation ??= []
            const existingIds = new Set(target.legislation.map(String))
            const newIds = legislation.filter((id) => !existingIds.has(String(id)))
            target.legislation.push(...newIds)
            notifyDraftStructureChanged()
        }
    }
}
